import {
  CreateItemGqlQuery,
  CreateItemGqlStatus,
  DateType,
  DeleteItemCacheKey,
  DeleteItemGqlQuery,
  DeleteItemGqlStatus,
  DeviceNanoId,
  FetchItemCacheKey,
  FetchItemGqlQuery,
  FetchItemsCacheKey,
  FetchItemsGqlQuery,
  FetchItemsLimit,
  FetchItemsPage,
  FileSize,
  FileUrl,
  ID,
  IdFilterType,
  ItemGqlError,
  ModelBrand,
  NanoID,
  UpdateItemGqlQuery,
  UpdateItemGqlStatus,
  UUID
} from '../../types';
import {
  UserFullName,
  UserImageFile,
  UserImageUUID,
  UserNanoID
} from '../users/usersTypes';

export type ImageCropID = ID;
export type ImageCropUUID = UUID;
export type ImageCropDownloadUrls = string[];
export type ImageCropNanoID = ModelBrand<NanoID, 'ImageCropNanoID'>;
export type ImageCropName = string;
export type ImageCropFile = FileUrl;
export type ImageCropSize = FileSize;
export type ImageCropPresignedUrl = string;
export type ImageCropDeviceNanoId = DeviceNanoId;
export type ImageCropCreatedAt = DateType;
export type ImageCropUserNanoId = UserNanoID;
export type ImageCropUserFullName = UserFullName;
export type ImageCropUserImageUUID = UserImageUUID;
export type ImageCropUserImageFile = UserImageFile;

export interface FetchImageCropsFilters {
  id?: IdFilterType;
}

export enum FetchImageCropsSortTypes {
  CREATED_AT_DESC = 'CREATED_AT_DESC'
}

export type FetchImageCropsGqlQuery = FetchItemsGqlQuery;
export type FetchImageCropGqlQuery = FetchItemGqlQuery;
export type CreateImageCropGqlQuery = CreateItemGqlQuery;
export type UpdateImageCropGqlQuery = UpdateItemGqlQuery;
export type DeleteImageCropGqlQuery = DeleteItemGqlQuery;
export type DownloadImageCropGqlQuery = UpdateItemGqlQuery;

export type CreateImageCropGqlStatus = CreateItemGqlStatus;
export type DeleteImageCropGqlStatus = DeleteItemGqlStatus;
export type DownloadImageCropGqlStatus = UpdateItemGqlStatus;
export type ImageCropGqlError = ItemGqlError;

export type FetchImageCropsCacheKey = FetchItemsCacheKey;
export type FetchImageCropCacheKey = FetchItemCacheKey;
export type FetchImageCropsPage = FetchItemsPage;
export type FetchImageCropsLimit = FetchItemsLimit;
export type FetchImageCropsSort = FetchImageCropsSortTypes[];

export type DeleteImageCropCacheKey = DeleteItemCacheKey;
export type DeleteImageCropCacheKeys = DeleteImageCropCacheKey[];
